export interface CreateNoveltyCheckTaskRequest {
    input: string;
    country: string[];
    task_id: string;
    legal_status: number[];
    include_company: string[];
    exclude_company: string[];
    apd_start: string;
    apd_end: string;
}

export type CreateNoveltyCheckTaskResponse = {
    task_id: string;
    text: string;
};

/**
 * 创建查新任务 API
 */
export interface FtoReportCreateTaskApi {
    /**
     * 创建查新任务
     * @param data 创建查新任务请求
     * @returns 创建查新任务响应
     */
    createNoveltyCheckTask(data: CreateNoveltyCheckTaskRequest): Promise<CreateNoveltyCheckTaskResponse>;
}

export const FtoReportCreateTaskApi = Symbol.for('FtoReportCreateTaskApi');
